export default __webpack_public_path__ + "static/media/snAiReview.267e568c.less";